import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { getZonedDate } from '@eika-infrastruktur/date';
import { DateInput } from '@eika/date-input';

import { useTranslation } from '../../translations';

export type BoligOvertakelseFormData = {
    overtakelsesDato: string;
};

const BoligOvertakelse: FC = () => {
    const { kjoepBolig, validationMessage } = useTranslation();
    const {
        control,
        formState: { errors },
    } = useFormContext<BoligOvertakelseFormData>();

    return (
        <div className="max-width-400">
            <Controller
                name="overtakelsesDato"
                control={control}
                rules={{ required: `${validationMessage.requiredValue}` }}
                render={({ field: { onChange, value } }) => (
                    <DateInput
                        label={kjoepBolig.labelOvertakelse}
                        placeholder="dd.mm.åååå"
                        date={value ? getZonedDate(value) : undefined}
                        minDate={getZonedDate(new Date())}
                        onChange={(value) => onChange(new Date((value as Date).setHours(2)))}
                        errorMessages={{
                            required: `${validationMessage.requiredValue}`,
                            invalid: `${validationMessage.invalidDato}`,
                            outOfRangeMin: `${validationMessage.minDato}`,
                            outOfRangeMax: `${validationMessage.maxDato}`,
                        }}
                        error={errors.overtakelsesDato?.message}
                    />
                )}
            />
        </div>
    );
};

export default BoligOvertakelse;
